var _path, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      minWidth: 32
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.45222 0H20.2711C20.8031 0 21.318 0.201095 21.7242 0.567584L28.8696 7.01431C29.375 7.47032 29.6665 8.1406 29.6665 8.84672V28.9333C29.6665 31.7982 29.6358 32 26.8808 32H8.45222C5.69718 32 5.6665 31.7982 5.6665 28.9333V3.06667C5.6665 0.2018 5.69718 0 8.45222 0Z",
    fill: "#E9EAEE"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 17,
    width: 19,
    height: 11,
    rx: 2,
    fill: "#A066AA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.43623 21.843V21.381H5.93323V20.8C5.93323 20.5013 6.01489 20.2867 6.17823 20.156C6.34156 20.0207 6.57956 19.953 6.89223 19.953C6.98089 19.953 7.07656 19.9577 7.17923 19.967V20.45C7.11389 20.4453 7.05323 20.443 6.99723 20.443C6.81523 20.443 6.68689 20.471 6.61223 20.527C6.53756 20.583 6.50023 20.6833 6.50023 20.828V21.381H7.17223V21.843H6.50023V25H5.93323V21.843H5.43623ZM7.65523 25V21.381H8.22223V25H7.65523ZM7.65523 20.695V19.995H8.22223V20.695H7.65523ZM9.01049 25V19.995H9.57749V25H9.01049ZM11.9174 25.098C11.3807 25.098 10.9537 24.9183 10.6364 24.559C10.3237 24.195 10.1674 23.74 10.1674 23.194C10.1674 22.6573 10.326 22.207 10.6434 21.843C10.9654 21.4743 11.3784 21.29 11.8824 21.29C12.4144 21.29 12.825 21.4767 13.1144 21.85C13.4037 22.2187 13.5484 22.711 13.5484 23.327H10.7484C10.7717 23.7097 10.8837 24.0223 11.0844 24.265C11.2897 24.503 11.5674 24.622 11.9174 24.622C12.4587 24.622 12.7924 24.3747 12.9184 23.88H13.4714C13.3874 24.2673 13.21 24.5683 12.9394 24.783C12.6687 24.993 12.328 25.098 11.9174 25.098ZM12.6384 22.046C12.4564 21.8407 12.2044 21.738 11.8824 21.738C11.5604 21.738 11.3037 21.8453 11.1124 22.06C10.9257 22.2747 10.809 22.5547 10.7624 22.9H12.9394C12.9207 22.536 12.8204 22.2513 12.6384 22.046Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.8419c88744814760d642172bfc835da2.svg";
export { ForwardRef as ReactComponent };